const MWS_FILE_SIZE = (bytes, dp = 1) => {
  const thresh = 1024
  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }
  const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  )

  return bytes.toFixed(dp) + ' ' + units[u]
}
/* eslint-disable no-control-regex */
const isValidEmail = (value) => {
  return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value)
}

const removeDuplicateItem = (items, key, value) => {
  let index = -1
  items.map((row, i) => {
    if (key !== '') {
      if (row[key] === value) {
        index = i
      }
    } else {
      if (row === value) {
        index = i
      }
    }
  })
  return index
}
const uniqByKeepFirst = (a) => {
  var dups = {}
  return a.filter(function (el) {
    var hash = el.valueOf()
    var isDup = dups[hash]
    dups[hash] = true
    return !isDup
  })
}
const customValidate = (elements) => {
  const validation = []
  for (let i = 0; i < elements.length; i++) {
    const element = elements[i]
    if (element.getAttribute('type') !== null && element.getAttribute('name') !== null) {
      if (element.value === '') {
        validation.push(1)
      } else {
        validation.push(0)
      }
    }
  }
  const valid = uniqByKeepFirst(validation)
  console.log(valid)
  if (valid.length === 1 && valid[0] === 0) {
    return true
  } else {
    return false
  }
}
export {
  MWS_FILE_SIZE,
  removeDuplicateItem,
  isValidEmail,
  uniqByKeepFirst,
  customValidate
}
